.trigger {
  display: inline;
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  color: var(--color-text);
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: var(--color-primary);
    }
  }
}

.backdrop {
  position: fixed;
  inset: 0;
  z-index: var(--layer-dialog-backdrop);
  background: color-mix(in srgb, var(--color-bg) 85%, transparent);

  transition:
    opacity var(--motion-fast) var(--motion-ease-out),
    transform var(--motion-fast) var(--motion-ease-out);

  &[data-starting-style],
  &[data-ending-style] {
    opacity: 0;
  }
}

.popup {
  position: fixed;
  z-index: var(--layer-dialog);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  width: min(var(--layout-dialog-max), calc(100vw - var(--space-32)));
  max-height: min(85vh, var(--layout-dialog-max-height));
  /* dvh — видимая высота: на телефоне панели браузера не обрезают низ окна */
  max-height: min(85dvh, var(--layout-dialog-max-height));
  background: var(--color-card);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-medium);
  box-shadow: var(--shadow-overlay);

  transition:
    opacity var(--motion-fast) var(--motion-ease-out),
    transform var(--motion-fast) var(--motion-ease-out);

  &[data-starting-style],
  &[data-ending-style] {
    opacity: 0;
  }

  &[data-starting-style],
  &[data-ending-style] {
    transform: translate(-50%, calc(-50% + var(--space-8)));
  }
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-16);
  padding: clamp(var(--space-18), 2.5vw, var(--space-28))
    clamp(var(--space-20), 3vw, var(--space-36)) var(--space-12);
  flex-shrink: 0;
  border-bottom: 1px solid var(--color-border);
}

.title {
  font-size: var(--type-dialog-title);
  color: var(--color-text);
}

.close {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-6);
  border: none;
  min-width: var(--layout-control-height);
  min-height: var(--layout-control-height);
  border-radius: var(--radius-small);
  background: transparent;
  color: var(--color-text);
  cursor: pointer;
  transition: background var(--motion-fast) ease;

  svg {
    width: 18px;
    height: 18px;
  }
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background: var(--color-card-hover);
    }
  }
}

.body {
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: var(--space-4) clamp(var(--space-20), 3vw, var(--space-36))
    clamp(var(--space-20), 3vw, var(--space-32));
}
